
<template>
  <div style="font-family: 'PingFangSC';">
    <div class="cominfo-header">企业中心 <span>/</span><span>订单中心</span><span>/</span><span>订单管理</span></div>
    <div class="orderTaskCont">
      <div class="orderTask-top">
        <div class="disFlex myordSear" style="align-items: center;">
          <span class="myordLabel">订单类型</span>
          <span :class="formInline.state==''?'active':''" @click="changeParams('state','')">全部</span>
          <span :class="formInline.state=='0'?'active':''" @click="changeParams('state','0')">待付款</span>
          <span :class="formInline.state=='1'?'active':''" @click="changeParams('state','1')">已付款</span>
          <span :class="formInline.state=='-1'?'active':''" @click="changeParams('state','-1')">已取消</span>
        </div>
      </div>
      <div class="disFlex between" style="height: 62px;align-items: center;">
        <div>
        </div>
        <div style="height: 36px;">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="">
              <el-input v-model="formInline.id" placeholder="请输入订单编号查询" clearable suffix-icon="el-icon-search">
              </el-input>
            </el-form-item>

            <el-form-item label="">
              <el-date-picker style="width: 284px;" @change="changeTime" v-model="rangTime" type="daterange"
                value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="" style="width: 130px;">
              <el-select v-model="formInline.payitype" placeholder="支付方式" clearable>
                <el-option label="微信支付" value="1"></el-option>
                <el-option label="支付宝支付" value="2"></el-option>
                <el-option label="银联支付" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="orderTask-cont" v-loading="loading">
        <div class="disFlex orderTask-cont-tit">
          <div class="th1">商品详情</div>
          <div class="th2">数量</div>
          <div class="th2">价格</div>
          <div class="th3">付款方式</div>
          <div class="th4">状态</div>
          <div class="th5">操作</div>
        </div>
        <div v-for="(item,k) in tableData.rows" :class="activeFlag==k?'orderTaskEvery avtive':'orderTaskEvery'">
          <div class="orderTaskEvery-tit">
            <span>订单编号：{{item.id}}</span><span style="padding-left: 36px;">购买日期：{{item.createTime}}</span>
          </div>
          <div class="disFlex" style="align-items: center;">
            <div class="disFlex td1">
              <div class="oreder-img"><img :src="wjSrc+item.img" @click="toProductInfo(item.productid)" style="cursor: pointer;" /></div>
              <div class="oreder-content disFlex">
                <div class="myordeve-kc-tit">{{item.productname}}</div>
                <div class="myordeve-kc-jdjs">总课时：{{item.allxstime}} | {{item.dnbuyamount}}人购买 |
                  有效期：{{item.endtime?item.endtime.substring(0,10):''}}</div>
              </div>
            </div>
            <div class="td2">x{{item.buyunchang?item.buyunchang:0}}</div>
            <div class="td2">¥{{item.price}}</div>
            <div class="td3">
              {{item.payitype=='1'?'微信支付':(item.payitype=='2'?'支付宝支付':(item.payitype=='3'?'银联支付':'-/-'))}}
            </div>
            <div class="td4">
              <span v-if="item.state=='-1'">已取消</span>
              <span v-else>{{item.state=='0'?'待付款':'已付款'}}</span>
            </div>
            <div class="td5">
              <el-tag type="warning" v-if="item.state=='0'" style="cursor: pointer;" @click="conselDd(item.id)">取消订单
              </el-tag>
              <el-tag type="primary" v-if="item.state=='0'" style="cursor: pointer;margin-top: 5px;"
                @click="toBuy(item.id)">付款
              </el-tag>
              <el-tag style="cursor: pointer;" v-else @click="delDd(item.id)">删除</el-tag>
            </div>
          </div>
        </div>
        <div v-if="tableData.rows.length==0" style="height: 200px;background-color: #fff;text-align: center;">
          <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
          <div style="font-size: 18px;color: #999999;">暂无数据</div>
        </div>


        <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
          :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Myorder',
    props: ['wjSrc', 'currentUser'],
    data() {
      return {
        params: {
          itypeSmall: 'all',
          itypeBig: 'all',
          isFinish: 'all',
          state: 'all'
        },
        formInline: {
          id: '',
          rows: 10,
          page: 1,
          payitype: '',
          state: '',
          createTime: '',
          endtime: '',
          creator: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        activeFlag: 1,
        rangTime: [],
        loading: true
      }
    },
    methods: {
      changeParams: function(key, val) {
        this.$set(this.formInline, key, val);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      getList: function() {
        this.loading = true;
        this.$axios.get('/kt/ktProductBuy/getlistPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;

          if (data.rows) {
            this.tableData = data;
          } else {
            this.$message.error(data.message);
          }
          this.loading = false;
        })
      },
      changeTime: function(val) {
        if (val) {
          this.$set(this.formInline, 'createTime', val[0]);
          this.$set(this.formInline, 'endtime', val[1])
        } else {
          this.$set(this.formInline, 'createTime', '');
          this.$set(this.formInline, 'endtime', '');
        }
      },
      // 取消订单
      conselDd: function(id) {
        this.$confirm('您确定要取消该订单吗?', '取消订单', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post('/kt/ktProductBuy/update2.htm', this.$qs.stringify({
            id: id,
            state: -1
          }), {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            if (data.stat == '1') {
              this.getList();
            } else {
              this.$message.error(data.message);
            }
          })
        }).catch(() => {});
      },
      // 删除订单
      delDd: function(id) {
        this.$confirm('您确定要删除该订单吗?', '删除订单', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/kt/ktProductBuy/del.htm?id=' + id, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            if (data.stat == '1') {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(data.message);
            }
          })
        }).catch(() => {});
      },
      // 跳转付款页面
      toBuy: function(id) {
        this.$router.push('/OrderInfo?id=' + id);
      },
      // 跳转产品详情
      toProductInfo: function(id) {
        this.$router.push('/ProductDetail?id=' + id);
      }
    },
    components: {},
    created: function() {
      this.$set(this.formInline, 'creator', this.currentUser.id);
      this.getList();
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList()
        },
        deep: true //true 深度监听
      }
    }
  }
</script>


<style>
  .orderTaskCont {
    background-color: #fff;
    margin-top: 20px;
    border-radius: 4px;
  }

  .orderTask-top {
    border-bottom: 1px solid #f2f2f2;
    padding: 20px 20px 15px 20px;

  }

  .myordSear {
    margin-bottom: 15px;
  }

  .myordSear span {
    margin-right: 15px;
    padding: 3px 15px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 20px;
    cursor: pointer;
  }

  .myordSear span.active {
    background: #e4f3fc;
    color: #0071BA;
    border-radius: 13px;
  }

  .myordSear span.myordLabel {
    height: 20px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    /* margin-right: 24px; */
    padding: 3px 0;
    width: 90px;
    display: inline-block;
  }

  .orderTask-cont {
    /* width: 923px; */
    margin: 20px auto;
    padding-bottom: 20px;
  }

  .orderTask-cont-tit {
    /* width: 923px; */
    height: 52px;
    border: 1px solid #efefef;
    border-radius: 4px;
    line-height: 52px;
    text-align: center;
  }

  .orderTask-cont-tit .th1 {
    width: 30vw;
  }

  .orderTask-cont-tit .th2 {
    width: 8vw;
  }

  .orderTask-cont-tit .th3 {
    width: 8vw;
  }

  .orderTask-cont-tit .th4 {
    width: 10vw;
  }

  .orderTask-cont-tit .th5 {
    width: 10vw;
  }

  .orderTaskEvery {
    /* width: 923px; */
    height: 161px;
    opacity: 1;
    border: 1px solid #efefef;
    border-radius: 4px;
    margin-top: 23px;
    text-align: center;
  }

  .orderTaskEvery-tit {
    line-height: 52px;
    height: 52px;
    opacity: 1;
    background: #efefef;
    border-radius: 4px 4px 0px 0px;
    padding-left: 23px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #333333;
  }

  .orderTaskEvery .td1 {
    width: 30vw;
    text-align: left;
    align-items: center;
    height: 109px;
  }

  .orderTaskEvery .td1 img {
    width: 103px;
    height: 77px;
    opacity: 1;
    border-radius: 6px;
    margin-left: 20px;
    margin-right: 7px;
  }

  .oreder-content {
    flex-direction: column;
    justify-content: space-between;
    height: 77px;
  }

  .orderTaskEvery .td1 .myordeve-kc-tit {
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
  }

  .orderTaskEvery .td1 .myordeve-kc-jdjs {
    height: 18px;
    opacity: 1;
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 18px;
  }

  .orderTaskEvery .td2 {
    width: 8vw;
  }

  .orderTaskEvery .td3 {
    width: 8vw;
  }

  .orderTaskEvery .td4 {
    width: 10vw;
  }

  .orderTaskEvery .td5 {
    width: 10vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/OrderTask.vue